module.exports = __webpack_public_path__ + "img/Bent Necklace.bf9fe41c.png";